/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import MultiFactorAuthenticationSetupButtons from 'components/Profile/MultiFactorAuthenticationSetup/components/MultiFactorAuthenticationSetupButtons';
import { Button } from '@mui/material';

type MFADisableSettingsProps = {
  data: {
    mfaEnabled?: boolean;
  };
  mfaHandleDisable: (proof: {
    currentPassword: string;
    twoFactorCode: string;
  }) => void;
  generateRecoveryCodes: () => void;
  noBtnText?: string;
  noBtnClick: () => void;
  yesBtnText: string;
  yesBtnClick: () => void;
};

const MFADisableProofForm: React.FC<{
  onSubmit: MFADisableSettingsProps['mfaHandleDisable'];
  onCancel: () => void;
}> = ({ onSubmit, onCancel }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [twoFactorCode, setTwoFactorCode] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitted(true);
    if (!currentPassword || !twoFactorCode.trim()) return;
    onSubmit({ currentPassword, twoFactorCode: twoFactorCode.trim() });
  };

  return (
    <form className="d-block" onSubmit={handleSubmit} noValidate>
      <p className="text-body text-small">
        Enter your current password and a code from your authenticator app or a
        recovery code to disable multi-factor authentication.
      </p>
      <div className="formGroup mb-3">
        <label htmlFor="mfa-disable-password" className="text-body text-small">
          Current password
        </label>
        <input
          id="mfa-disable-password"
          type="password"
          autoComplete="current-password"
          className="form-control"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />
        {submitted && !currentPassword && (
          <span className="text-danger text-small">Required</span>
        )}
      </div>
      <div className="formGroup mb-3">
        <label htmlFor="mfa-disable-code" className="text-body text-small">
          Multi-factor code
        </label>
        <input
          id="mfa-disable-code"
          type="text"
          autoComplete="one-time-code"
          className="form-control"
          value={twoFactorCode}
          onChange={(e) => setTwoFactorCode(e.target.value)}
        />
        {submitted && !twoFactorCode.trim() && (
          <span className="text-danger text-small">Required</span>
        )}
      </div>
      <div className="row">
        <div className="col-12 justify-content-end formbtn">
          <div className="btn-wrap btn--leftspace">
            <button
              type="button"
              className="btn btn-outline-light"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Disable
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export const MFADisableSettings: React.FC<MFADisableSettingsProps> = ({
  data,
  mfaHandleDisable,
  generateRecoveryCodes,
  noBtnText,
  noBtnClick,
  yesBtnText,
  yesBtnClick,
}) => {
  const [askingProof, setAskingProof] = useState(false);

  if (askingProof) {
    return (
      <MFADisableProofForm
        onSubmit={mfaHandleDisable}
        onCancel={() => setAskingProof(false)}
      />
    );
  }

  return (
    <div className="d-block">
      <div className="formGroup mb-3">
        <label className="text-body text-small mb-0">Status</label>
        <div className="lblValue">
          {data?.mfaEnabled && (
            <div>
              <span className="fontSize">Enabled</span>
              <a
                onClick={() => setAskingProof(true)}
                className="fontSize font-weight-bold ml-2"
              >
                Disable
              </a>
            </div>
          )}
        </div>
      </div>
      <div className="formGroup mb-3">
        <label className="text-body text-small mb-0">Access</label>
        <div className="lblValue">
          <Button
            variant="text"
            className="fontSize font-weight-bold link px-0"
            onClick={generateRecoveryCodes}
          >
            Generate Recovery Codes… <i className="iconCode">?</i>
          </Button>
        </div>
      </div>
      <MultiFactorAuthenticationSetupButtons
        noBtnText={noBtnText}
        noBtnClick={noBtnClick}
        yesBtnText={yesBtnText}
        yesBtnClick={yesBtnClick}
      />
    </div>
  );
};
